var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_shared-key.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_shared-key.js
// module chunks = 6